/**
 * Configuration constants for Medical Assistant auto-assignment
 */

/**
 * Default daily appointment limit per Medical Assistant
 * This prevents any single MA from being overloaded with appointments in one day
 */
export const DEFAULT_DAILY_MA_LIMIT = 5;

/**
 * Maximum number of retry attempts for fetching weekly assignment data
 * before falling back to degraded mode
 */
export const MAX_WEEKLY_DATA_FETCH_RETRIES = 3;

/**
 * Error count threshold for showing degraded mode notifications to users
 */
export const ERROR_NOTIFICATION_THRESHOLD = 2;

/**
 * Environment-based fallback MA IDs for assignment
 * Used when no other eligible MAs are found for specialty-specific assignment
 */
export const FALLBACK_MA_BY_ENV: Record<string, string | null> = {
  dev: null, // No fallback in dev
  stage: null, // No fallback in stage
  prod: "d3cc2ebb-2b48-4847-bbea-6e79d5baed4c", // Helen Jiang in prod
};
